import config from "../../config/config";
/* Datamodel to be sent to tealium tracking server */

export default (trackingObject, pageData, clickTracking = false, clickData) => {
    trackingObject.abTest_id = pageData.testId;
    trackingObject.abTest_name = pageData.testName;
    trackingObject.abTest_version = ((!pageData.testIndex && pageData.testIndex !== 0) || pageData.testIndex < 0) ? "no_test" : config.versionLetters[pageData.testIndex];
    if(clickTracking) {
        trackingObject.abTest_main_click_url = (clickData && clickData.href) ? clickData.href : pageData.trigger.href;
        let text = "";
        if(clickData && clickData.text) {
            text = clickData.text;
        } else {
            text = pageData.trigger.path.split("[");
            text = text[text.length - 1].replace("]", "");
        }
        trackingObject.abTest_main_click_text = text.replace(/(\r\n|\n|\r)/gm, "-");
        trackingObject.tealium_event = "abtest_click";
    }
    (clickTracking) ? window.utag.link(trackingObject) : window.utag.view(trackingObject);
}
